import React, { useRef } from 'react'
import locationImg from '../../../assets/images/location.svg'
import { Autocomplete, Box, CardActionArea, CircularProgress, TextField, Tooltip, Typography } from '@mui/material'
import searchImg from '../../../assets/images/search.svg'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../reduxState/store'
import { fetchSearch, clearState } from '../../../reduxState/searchSlice/searchGetall'
import { Gallery_BASE_URL } from '../../../config'
import sampleImage from '../../../assets/images/sampleInfoImage.png'
import { useNavigate } from 'react-router-dom'
import searchEmpty from '../../../assets/images/searchEmpty.webp'
import SearchSkeleton from '../skeleton/searchSkeleton'
import MyLocation from '../location'

const HeaderSearch: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const searchList = useSelector((state: RootState) => state.searchList);
  const [stateLoading, setStateLoading] = React.useState<boolean>(false);
  const [stateText, setStateText] = React.useState<any>('');
  const [location, setLocation] = React.useState<any>('');
  const [search, setSearch] = React.useState<any>('');
  const navigate = useNavigate()
  const boxRef = useRef(null);

  React.useEffect(() => {
    const handleOutsideClick = () => {
      setStateLoading(false)
      dispatch(clearState())
    };
    document.addEventListener('click', handleOutsideClick);
    return () => {
      setStateText('')
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  React.useEffect(() => {
    if (search.length > 1) {
      const delayDebounceFn = setTimeout(() => {
        dispatch(fetchSearch({ search: search }))
      }, 1000)
      return () => clearTimeout(delayDebounceFn)
    }
  }, [search])

  const searchOnchange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(clearState())
    setStateText(event.target.value)
    setSearch(event.target.value)
    setStateLoading(true)
    if (event.target.value === "") {
      setStateLoading(false)
    }
  }

  const cityDetails = [
    { label: 'Chennai', id: 1 },
    { label: 'Trichy', id: 2 },
    { label: 'Madurai', id: 3 },
    { label: 'Villupuram', id: 4 }
  ]

  const handleSearch = (search: any) => {
    if (search.branchId === null) {
      setStateText(search.name)
      navigate("/category-merchant/list", { state: search.id })
      dispatch(clearState())
      setStateLoading(false);
      setTimeout(() => {
        setStateText('')
      }, 20000)
    } else {
      const data = {
        id: search.branchId,
        type: 'product'
      }
      setStateText(search.name)
      navigate("/merchant-product/list", { state: data })
      dispatch(clearState())
      setStateLoading(false);
      setTimeout(() => {
        setStateText('')
      }, 20000)
    }
  }

  return (
    <Box display={'flex'} className='search-input'>
      <MyLocation setLocation={setLocation}/>
      <img src={locationImg} alt="Location image" width={'4%'} style={{ padding: '0 8px 0 16px' }} loading='lazy' />
      <Tooltip title={location}>
        <TextField
          value={location || 'Chennai'}
          className='autocomplete-city'
          sx={{ width: '30%' }}
          disabled
        />
      </Tooltip>
      <TextField
        variant="outlined"
        type='search'
        size="small"
        value={stateText}
        placeholder='Search for restaurant, category or a dish'
        className='border-search'
        sx={{ width: '70%' }}
        onChange={searchOnchange}
        InputProps={{
          autoComplete: 'off',
        }}
      />
      <Box mr={2}>
        <img src={searchImg} alt="Search image" style={{ fontSize: '1.75rem' }} loading='lazy' />
      </Box>
      {stateLoading ?
        <Box
          className='search-popover'
          ref={boxRef}
        >
          {searchList.data.length > 0 ?
            <>
              {searchList.data.map((search: any, index) => (
                <CardActionArea onClick={() => handleSearch(search)} key={index}>
                  <Box display={'flex'} alignItems={'center'} p={3}>
                    <Box>
                      {search.image === null || search.image === '' ?
                        <img src={sampleImage} alt={search.name} width={53} height={53} style={{ borderRadius: '50%', objectFit: 'cover' }} loading='lazy' /> :
                        <img src={`${Gallery_BASE_URL}${search.image}`} alt={search.name} width={53} height={53} style={{ borderRadius: '50%', objectFit: 'cover' }} loading='lazy' />
                      }
                    </Box>
                    <Box pl={4}>
                      <Typography className='reem-kulfi search-name'>{search.name}</Typography>
                      {search.type === "branch" ?
                        <Typography className='reem-kulfi search-type'>Restaurant</Typography> :
                        <Typography className='reem-kulfi search-type'>{search.type}</Typography>
                      }
                    </Box>
                  </Box>
                </CardActionArea>
              ))}
            </> :
            searchList.code === 204 ?
              <Box textAlign={'center'} my={5}>
                <img src={searchEmpty} alt="No data available" width={200} height={200} loading='lazy' />
              </Box> :
              <SearchSkeleton listsToRender={8} />
          }
        </Box> :
        null}
    </Box>
  )
}

export default HeaderSearch